<template>
  <div class="feedback">
    <div class="table"
         v-if="!showInfo">
      <div class="head">
        <div>我删除的试卷</div>
         <div style="display:flex; width:290rem;margin-left: 520rem; ">
          <div style="width:90rem">科目</div>
        <a-select v-model:value="subjectId"
                        placeholder="请选择科目"
                        size="large"
                        @change="changeSubject"
                        style="width:100%">
                <a-select-option v-for="item in subjectList"
                                 :key="item.subject_id"
                                 :value="item.subject_id">
                  {{item.subject_name}}
                </a-select-option>
              </a-select>
              </div>
      </div>
     
      <a-table :columns="columns"
               style="width: 100%"
               :scroll="{  y: 650 }"
               :data-source="tableData">
        <template #bodyCell="{ column, record }">

          <div v-if="column.key == 'paper_desc'">
            <span  >
              
              {{record.paper_desc||''}}

            </span>
            <br>
              <span  >试卷ID: {{record.user_paper_id}}</span>
          </div>
          
           <div v-if="column.key == 'template_name'">
            <span  >
                     {{ record.template_name||''}}
            </span>
          </div>
          <div v-if="column.key == 'correct_type'">
            <span  >
                     {{typeList[record.correct_type] }}
            </span>
          </div>
          <div v-else-if="column.key == 'opertion'">
            <div class="btn"
                 @click="recover(record)">
              恢复
            </div>
          </div>
        </template>
      </a-table>
    </div>

    <div v-else>
      <div class="head">
        题目详情
      </div>

      <div class="warp">
        <div class="topic_head">题目内容</div>
        <div v-html="info.question_content"
             class="btm_bdr">
        </div>
      </div>
      <div class="warp">
        <div class="topic_head">
          题目答案
        </div>
        <div v-html="info.question_answer"
             class="btm_bdr">
        </div>
      </div>

      <div class="warp">
        <div class="topic_head">
          题目解析
        </div>
        <div v-html="info.question_explain"
             style="font-size:22rem"></div>

      </div>
      <a-row :gutter="10"
             style="margin-top:10px"
             v-if="info.category == 1">
        <span class="comment">
          分数：{{info.user_score}}
        </span>
      </a-row>

      <a-row :gutter="10"
             style="margin-top:10px"
             v-if="info.category == 1">
        <span class="comment">
          评语：{{info.comment_to_user}}
        </span>
      </a-row>
      <a-row :gutter="10">
        <a-col :span="24">
          <div :class="`status_btn ${getStatusClass(info.status)}`">
            {{getValue(info.status)}}
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="10"
             v-if="info.teacher_comment">
        <span class="comment">
          未通过原因：{{info.teacher_comment}}
        </span>
      </a-row>
      <div class="img_wrap">
        <a-image v-for="(item,index) in info.counter_image"
                 :key="index"
                 style="width: 100px; height: 100px;margin-right:10px;border-radius:10px"
                 :src="item"
                 :preview-src-list="info.counter_image">
        </a-image>
      </div>

      <div style="width:100px;height:30px"></div>
    </div>

  </div>
</template>

<script setup>
import { reactive, ref } from "@vue/reactivity"
 import { getUserSubject } from '@/api/subject.js'
 import { message, Modal } from 'ant-design-vue'
import { myDelPaper, recoverDelPaper } from '@/api/my_paper.js'
import { onMounted } from "@vue/runtime-core"
import { rands } from '@/utils/rand.js'
let columns = [
  {
    title: '试卷名称',
    dataIndex: 'paper_desc',
    key: 'paper_desc',
  },
  {
    title: '组卷类型',
    dataIndex: 'template_name',
    key: 'template_name',
  },
  {
    title: '批改类型',
    dataIndex: 'correct_type',
    key: 'correct_type',
  },
  {
    title: '试卷时间',
    dataIndex: 'paper_time',
    key: 'paper_time',
  },
    {
    title: '删除时间',
    dataIndex: 'del_time',
    key: 'del_time',
  },
  {
    title: '操作',
    dataIndex: 'opertion',
    key: 'opertion',
  },
]
const   typeList={
  1: '平台',
  2: '学生自评',
  3: '学校老师',
  5: '教研部',
  6: '兼职老师',
  7: '指定教师组',
  8: '出卷老师'
}
let subjectList = ref([])
let subjectId = ref('')
let tableData = ref([])
let showInfo = ref(false)
let info = reactive({})
let  moduleList = reactive({
        1: '自组组卷',
        // 2: '考点组卷',
        3: '整卷组卷',
        4: '考点组卷',
        5: '章节组卷'
      }
    )
onMounted(() => {
  getSubject()
  getList()
})
const changeSubject = (val) => {
  subjectId.value = val
   getList() 
}
const getValue = (status) => {
  console.log('status', status)
  var str = ''
  switch (status) {
    case -1:
      str = '未通过'
      break;
    case 0:
      str = '待审核'
      break;
    case 1:
      str = '审核通过'
      break;
    case 2:
      str = '修改完成'
      break;
  }
  return str;
}
const getSubject = async () => {

  const { data } = await getUserSubject()
  subjectList.value = data.list
  if(data.list[0].subject_id){
      subjectId.value = data.list[0].subject_id
  }
 getList()

}
const getColor = (status) => {
  var color = ''
  switch (status) {
    case -1:
      color = '#FF664E'
      break;
    case 0:
      color = '#1584F0'
      break;
    case 1:
      color = '#2ACE84'
      break;
    case 2:
      color = '#2ACE84'
      break;
  }
  return color;
}

const getStatusClass = (status) => {
  var classname = '';
  switch (status) {
    case -1:
      classname = 'wtg'
      break;
    case 0:
      classname = 'wsh'
      break;
    case 1:
      classname = 'tg'
      break;
    case 2:
      classname = 'tg'
      break;
  }
  return classname
}

const getList = async () => {
  console.log('subjectId', subjectId.value,subjectId.value=='')
    if (subjectId.value=='') {
        return
      }
  const { data } = await myDelPaper({subject_id: subjectId.value})
  tableData.value = data.volist
}
const recover = async (row) => {
    Modal.confirm({
      title: '提示',
      content: '确定恢复删除的试卷？',
      async onOk () {
           let params = {
    user_paper_id: row.user_paper_id
  }
  const  data  = await recoverDelPaper(params)
  console.log(data)
  if(data.status == 200){
     message.success('恢复成功')
       getList()
  }
       
      },
      onCancel () {
        
      },
    });
 
 
}
</script>

<style lang="scss" scoped>
.feedback {
  width: calc(100% - 140rem);
  margin: 0 auto;
  padding-top: 40rem;
  height: 100%;
  overflow: auto;
  .head {
    font-size: 28rem;
    font-weight: 600;
    color: #000000;
    display: flex;
    
    margin-bottom: 28rem;
    line-height: 42px;
  }
   
}
.btn {
  background: #d8e6fc;
  color: #1584f0;
  font-size: 16rem;
  font-weight: bold;
  padding: 5px 0;
  border-radius: 20px;
  width: 110px;
  margin: 0 auto;
  float: right;
  margin-right: -10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
:deep .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
   width: 214rem;
height: 44rem;
  font-size: 24rem;
 
  border-radius: 8px;
}
::v-deep .el-table tr {
  box-shadow: 0px 0px 0px 0px rgba(229, 229, 229, 1);
  border-radius: 5px;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
}

::v-deep .el-table th,
.el-table tr {
  background: #f6f6f6 !important;
}

.text {
  font-size: 24rem;
  font-weight: bold;
  color: #000000;
}
.warp {
  .topic_head {
    font-size: 22rem;
    font-weight: bold;
    color: #000000;
    border-left: 6rem solid #37a0f4;
    text-indent: 14rem;
    height: 22rem;
    line-height: 22rem;
    margin-bottom: 10px;
  }
}
.btm_bdr {
  border-bottom: 2rem solid #cccccc;
  margin-bottom: 18rem;
  font-size: 22rem;
}
.status_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150rem;
  height: 48rem;
  border-radius: 35rem;
  font-size: 22rem;
  font-weight: bold;
  margin-top: 25rem;
}
.wsh {
  background: #d8e6fc;
  color: #007af0;
}
.wtg {
  background: #fedddd;
  color: #ff664e;
}
.tg {
  background: #e4f9ed;
  color: #2ace84;
}
.comment {
  font-size: 14px;
  font-weight: bold;
  color: #000000;
}
.img_wrap {
  display: flex;
  flex-wrap: wrap;
}
:deep .ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  font-size: 24rem;
}
</style>